var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopParallax',{attrs:{"title":"BULLETINS & NEWSLETTERS","img-src":_vm.imgSrc}}),_c('bulletin-alert'),_c('bulletin-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }